import PropTypes from "prop-types";

import * as styles from "../../styles/SchoolReportCardStatistics.module.scss";

/**
 * School-level rollup for Report Card Overview (historical always; current year when grading windows allow).
 * @name SchoolReportCardStatistics
 * @param {string} props.schoolName
 * @param {{ ytd: { summary: string }, semester: { summary: string } }} props.rollup
 * @returns {JSX.Element}
 */
const SchoolReportCardStatistics = ({ schoolName, rollup }) => {
    return (
        <div
            className={styles.container}
            data-testid="historical-location-rollup"
            aria-label="School report card statistics"
        >
            <h4 className={styles.schoolName}>{schoolName}</h4>
            <div className={styles.statsBlock}>
                <div className={styles.group}>
                    <h5 className={styles.title}>School Report Card Statistics</h5>
                    <span className={styles.label}>School Year</span>
                    <span className={styles.summary} dangerouslySetInnerHTML={{ __html: rollup.ytd.summary }} />
                </div>
                <div className={styles.group}>
                    <span className={styles.label}>Semester</span>
                    <span className={styles.summary} dangerouslySetInnerHTML={{ __html: rollup.semester.summary }} />
                </div>
            </div>
        </div>
    );
};

SchoolReportCardStatistics.propTypes = {
    schoolName: PropTypes.string.isRequired,
    rollup: PropTypes.shape({
        ytd: PropTypes.shape({
            summary: PropTypes.string.isRequired
        }).isRequired,
        semester: PropTypes.shape({
            summary: PropTypes.string.isRequired
        }).isRequired
    }).isRequired
};

export default SchoolReportCardStatistics;
